import React from 'react';
import PropTypes from 'prop-types';

const WaitingComponent = ({ text, showSpinner, visible }) => {
  if (!visible) return (<></>);

  return (
    <div
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 101,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '2em',
        color: 'white',
        userSelect: 'none',
      }}
    >
      <span>
        {showSpinner && (<i className="fa fa-spin fa-spinner" style={{ fontSize: 'inherit' }} />)}
        {' '}
        {text}
      </span>
    </div>
  );
};

WaitingComponent.propTypes = {
  showSpinner: PropTypes.bool,
  text: PropTypes.string,
  visible: PropTypes.bool.isRequired,
};

WaitingComponent.defaultProps = {
  showSpinner: true,
  text: 'Wait...',
};

export default WaitingComponent;
